export default __webpack_public_path__ + "static/media/settings.714b3880.gif";